/**
 * @generated SignedSource<<59d658713c84a8a04cbeafca9086de3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedResultContainer_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_user">;
  readonly " $fragmentType": "BuySharedResultContainer_user";
};
export type BuySharedResultContainer_user$key = {
  readonly " $data"?: BuySharedResultContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedResultContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedResultContainer_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2800a32f560879a70e44c72b04adbbbf";

export default node;
